import React from 'react';

import Field from 'src/views/components/Form/Field';

import JiraFiledValueSelector, { isFieldSupported } from './ActionAdditionalValueSelector/JiraFiledValueSelector';

const specialFields = (field) => {
  const { apiName, operations, issueTypeIds } = field;
  if ([
    'project',
    'issueType',
  ].includes(apiName)) return [];

  if (apiName === 'summary' && operations.length === 1 && operations[0] === 'set') {
    return [{
      name: 'jira_prefix_summary',
      label: 'Prefix summary',
      type: 'issue_create',
      restrictToIssueTypes: issueTypeIds,
      AdditionalParams: ({ name, values = {}, touched = false, errors = null, onChange, onBlur }) => (
        <Field label="Prefix summary">
          <JiraFiledValueSelector
            isMulti
            field={field}
            name={`${name}.jira_prefix_summary`}
            value={values.jira_prefix_summary}
            onChange={onChange}
            onBlur={onBlur}
          />
        </Field>
      )
    }];
  }

  if (apiName === 'description' && operations.length === 1 && operations[0] === 'set') {
    return [{
      name: 'jira_append_description',
      label: 'Add description',
      type: 'issue_create',
      restrictToIssueTypes: issueTypeIds,
      AdditionalParams: ({ name, values = {}, touched = false, errors = null, onChange, onBlur }) => (
        <Field label="Fields to add to description">
          <JiraFiledValueSelector
            isMulti
            field={field}
            name={`${name}.jira_append_description`}
            value={values.jira_append_description}
            onChange={onChange}
            onBlur={onBlur}
          />
        </Field>
      )
    }];
  }

  return undefined;
};

const generateUnknownField = ({ apiName, name, issueTypeIds }) => [{
  name: `unsupported_${apiName}`,
  label: name || apiName,
  type: 'unsupported_jira_field',
  restrictToIssueTypes: issueTypeIds,
}];


const generateActionsByField = field => {
  const { operations, schema: { type, custom } = {}, name, apiName, issueTypeIds } = field || {};
  const specialField = specialFields(field);
  if (specialField) return specialField;

  const supportedOperations = ['set', 'add', 'remove'].filter(op => operations.includes(op));
  const isMulti = type === 'array' || custom === 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';

  if (supportedOperations.length > 0 && isFieldSupported(field)) {
    return supportedOperations.map(operation => {
      const actionName = `jira_field_${operation}_${apiName}`;
      const actionLabel = `${(operation.charAt(0).toUpperCase() + operation.slice(1)).replace('_', ' ')} ${name}`;

      return {
        name: actionName,
        label: actionLabel,
        type: 'issue_create,issue_update',
        restrictToIssueTypes: issueTypeIds,
        AdditionalParams: ({ name, values = {}, touched = false, errors = null, onChange, onBlur }) => (
          <Field label={actionLabel}>
            <JiraFiledValueSelector
              isMulti={isMulti}
              field={field}
              name={`${name}.${actionName}`}
              value={values[actionName]}
              onChange={onChange}
              onBlur={onBlur}
            />
          </Field>
        )
      };
    });
  } else {
    if (operations.length === 0) return [];
    return generateUnknownField(field);
  }
};

const generateJiraFieldUpdateActions = (fields) => {
  return fields.flatMap(generateActionsByField);
};

export { generateJiraFieldUpdateActions };
